// src/lib/modules/SpecialCollections/SpecialCollectionDetails/SpecialCollectionActionMenu/index.js

import { connect } from "react-redux";

import { deleteSpecialCollection } from "../state/actions";
import SpecialCollectionActionMenuComponent from "./SpecialCollectionActionMenu";

const mapStateToProps = (state) => ({
  isLoading: state.specialCollectionDetails.isLoading,
  error: state.specialCollectionDetails.error,
  specialCollection: state.specialCollectionDetails.data,
  hasError: state.specialCollectionDetails.hasError,
  relations: state.recordRelations?.data || {},
});

const mapDispatchToProps = (dispatch) => ({
  deleteSpecialCollection: (specialCollectionPid) =>
    dispatch(deleteSpecialCollection(specialCollectionPid)),
});

export const SpecialCollectionActionMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialCollectionActionMenuComponent);
